export enum TimesheetType {
  SHIFT = 'SHIFT',
  TIMESHEET = 'TIMESHEET',
  LOCATION = 'LOCATION',
}